import { ReactNode } from 'react';
import { withStyles, Box } from 'vopay';
import { Card, MaterialSymbol, Title } from 'UI';
import styles from './DefaultFundingMethods.module.scss';

const cn = withStyles(styles);

type MaterialSymbolIcon = React.ComponentProps<typeof MaterialSymbol>['icon'];

export type FundingMethodModuleProps = {
  icon: MaterialSymbolIcon;
  iconFill?: number;
  title: string;
  children: ReactNode;
};

export default function FundingMethodModule({ icon, iconFill, title, children }: FundingMethodModuleProps) {
  return (
    <Card className={cn('module')} hoverEffect={false}>
      <div className={cn('moduleHeader')}>
        <MaterialSymbol icon={icon} fillAmount={iconFill} size="24px" />
        <Title level="4">{title}</Title>
      </div>
      <Box className={cn('rows', 'scrollbar')} flx="col" grow="1">
        {children}
      </Box>
    </Card>
  );
}
